import { apiAxios } from '@/modules/core/app/helpers/AxiosHelper';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';

const MCPCHAT_REQUEST_TIMEOUT_MS = 240000;

class McpChatResource {
  /**
   * @param {string} message
   * @param {string|null} conversationId
   * @returns {Promise<{message: string, conversation_id: string, tools_used: string[]}>}
   */
  async sendMessage(message, conversationId = null, pageContext = null) {
    const payload = { message };
    if (conversationId) {
      payload.conversation_id = conversationId;
    }
    if (pageContext) {
      payload.page_context = pageContext;
    }
    return apiAxios.post(RouteGroup.MCPCHAT, payload, { timeout: MCPCHAT_REQUEST_TIMEOUT_MS });
  }

  async executeAgent(agentKey, contextPayload, conversationId = null, pageContext = null) {
    const payload = {
      agent_execution: {
        agent_key: agentKey,
        context_payload: contextPayload || {},
      },
    };
    if (conversationId) {
      payload.conversation_id = conversationId;
    }
    if (pageContext) {
      payload.page_context = pageContext;
    }
    return apiAxios.post(RouteGroup.MCPCHAT, payload, { timeout: MCPCHAT_REQUEST_TIMEOUT_MS });
  }

  async getHistory(params = {}) {
    return apiAxios.get(RouteGroup.MCPCHAT_HISTORY, {
      params,
      timeout: 30000,
    });
  }

  async getConversation(conversationId) {
    return apiAxios.get(`${RouteGroup.MCPCHAT_HISTORY}/${conversationId}`, { timeout: 30000 });
  }

  async getSuggestionPrompts() {
    return apiAxios.get(RouteGroup.MCPCHAT_SUGGESTION_PROMPTS);
  }
}

export default new McpChatResource();
